/**
 * Liantiao Jamaica - Welcome Page
 * Jamaica-themed marketplace and delivery landing page
 * Links to /shop for full Tropical Marketplace experience
 */
import Navbar from '@/components/layout/Navbar';
import HeroSection from '@/components/sections/HeroSection';
import FeaturedStoresSection from '@/components/sections/FeaturedStoresSection';
import GiftCardShowcaseSection from '@/components/sections/GiftCardShowcaseSection';
import EventsRollSection from '@/components/sections/EventsRollSection';
import ClassifiedsPreviewSection from '@/components/sections/ClassifiedsPreviewSection';
import ShopPreviewSection from '@/components/sections/ShopPreviewSection';
import TrendingSection from '@/components/sections/TrendingSection';
import SellSection from '@/components/sections/SellSection';
import JoinUsSection from '@/components/sections/JoinUsSection';
import ServicesSection from '@/components/sections/ServicesSection';
import CoverageSection from '@/components/sections/CoverageSection';
import PUDOSection from '@/components/sections/PUDOSection';
import TestimonialsSection from '@/components/sections/TestimonialsSection';
import CTASection from '@/components/sections/CTASection';
import Footer from '@/components/sections/Footer';

const Welcome = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedStoresSection />
        <GiftCardShowcaseSection />
        <EventsRollSection />
        <ClassifiedsPreviewSection />
        <ShopPreviewSection />
        <TrendingSection />
        <SellSection />
        <JoinUsSection />
        <ServicesSection />
        <CoverageSection />
        <PUDOSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Welcome;
